import React, { ReactNode, Suspense } from "react";
import styled from "styled-components";
import { Colors } from "../../../theme/colors";
import { FontSizes } from "../../../theme/fonts";

type FormFieldType = "error";

interface FormFieldProps {
  children?: ReactNode;
  show: boolean;
  type: FormFieldType;
  message?: string;
}

const FormField = ({ children, show, type, message }: FormFieldProps) => {
  return (
    <Container>
      {children}
      {show && (
        <MessageWrapper>
          <Suspense fallback={null}>
            <IconSVG as={getIconSVG(type)} />
          </Suspense>
          <Label>{message}</Label>
        </MessageWrapper>
      )}
    </Container>
  );
};

const getIconSVG = (type: FormFieldType) => {
  switch (type) {
    case "error":
      return InfoSVG;
  }
};

const Container = styled.div``;

const MessageWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin-top: ${4 * 2}px;
  align-items: center;
`;

const Label = styled.div`
  flex: 1;
  color: ${Colors.Error};
  font-size: ${FontSizes.Paragraph};
`;

const IconSVG = styled.div`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  fill: ${Colors.Error};
  margin-right: ${4 * 2}px;
`;

const InfoSVG = React.lazy(() => import("../../atoms/Svg/InfoSVG"));

export default FormField;
